import { Link } from 'react-router-dom'
import { PARTNERS, productsForPartner } from '../lib/partners'
import { useI18n } from '../lib/i18n'

export default function Marketplace() {
  const { t } = useI18n()
  return (
    <div className="section py-14">
      <div className="max-w-3xl">
        <p className="text-sm font-semibold uppercase tracking-wide text-brand-400">{t('Partner marketplace')}</p>
        <h1 className="mt-3 text-4xl md:text-6xl font-black tracking-tight text-white">
          {t('Partner shops for selling Qordo demos locally.')}
        </h1>
        <p className="mt-5 text-lg text-ink-300 leading-8">
          {t('Each partner gets a public shop with a focused bundle of demos, a referral code, and a clear route for business owners to request a build. Joining is free; payouts follow the same €30 setup + 30% recurring model.')}
        </p>
        <div className="mt-7 grid gap-3 sm:grid-cols-3">
          <div className="card p-4">
            <strong className="block text-white">{t('Free partner account')}</strong>
            <span className="mt-1 block text-sm text-ink-400">{t('No listing fee, no ad spend required.')}</span>
          </div>
          <div className="card p-4">
            <strong className="block text-white">{t('Tracked referral code')}</strong>
            <span className="mt-1 block text-sm text-ink-400">{t('Leads are attributed to the shop that sent them.')}</span>
          </div>
          <div className="card p-4">
            <strong className="block text-white">{t('Demo-first selling')}</strong>
            <span className="mt-1 block text-sm text-ink-400">{t('Show a working product before asking for a call.')}</span>
          </div>
        </div>
      </div>

      <div className="mt-10 grid gap-5 md:grid-cols-3">
        {PARTNERS.map((partner) => {
          const products = productsForPartner(partner)
          return (
            <article key={partner.slug} className="card p-6 flex flex-col">
              <div className="text-xs font-mono text-brand-300">{partner.code}</div>
              <h2 className="mt-3 text-xl font-bold text-white">{partner.name}</h2>
              <p className="mt-1 text-sm text-ink-400">{t(partner.region)}</p>
              <p className="mt-4 text-sm text-ink-300 leading-6 flex-1">{t(partner.focus)}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {products.slice(0, 4).map((product) => (
                  <span key={product.slug} className="rounded-full border border-ink-700 px-3 py-1 text-xs text-ink-300">
                    {product.name}
                  </span>
                ))}
              </div>
              <Link to={`/partners/${partner.slug}`} className="btn-secondary mt-6 text-center text-sm">
                {t('View partner shop')}
              </Link>
            </article>
          )
        })}
      </div>

      <div className="mt-10 rounded-2xl border border-brand-500/30 bg-brand-500/10 p-6">
        <h2 className="text-xl font-bold text-white">{t('Want your own partner shop?')}</h2>
        <p className="mt-2 text-ink-300 leading-7">
          {t('Join free, choose the verticals you want to sell, and share a shop link with business owners in your region. Qordo keeps the demo shelf and commission tracking in one place.')}
        </p>
        <Link to="/signup" className="btn-primary mt-5 inline-flex">{t('Join as partner - free')}</Link>
      </div>
    </div>
  )
}
